<template lang="pug">
  .b-buttons-row._w-full
    div
      button.b-button._icon._fa(
        ref="microphone"
        type="button"
      )
        font-awesome-icon(
          icon="microphone-alt"
          fixed-width
        )

    AudioPlayer(
      v-if="item.recordSrc"
      :file="item.recordSrc"
      :key="item.recordSrc"
    )

    tippy(
      :to="`record-${item.id}`"
      :triggerTarget="$refs.microphone"
      arrow
      trigger="click"
      :interactive="true"
      theme="light"
      @shown="opened = true"
      @hidden="opened = false"
    )
      .b-buttons-panel._audio-recorder(
        v-if="opened"
        :style="{'--scale': layoutScale}"
      )
        .b-buttons-row
          AudioRecorder(
            :file="item.recordSrc"
            @stopped="stopped"
          )
        .b-buttons-row(v-if="item.recordSrc")
          button.b-button._icon._fa(
            v-if="item.recordSrc"
            type="button"
            @click="deleteRecord"
          )
            font-awesome-icon(
              icon="trash-alt"
              :style="iconStyle"
              fixed-width
            )
</template>

<script>
import AudioRecorder from '@/components/audio/AudioRecorder';
import AudioPlayer from '@/components/audio/AudioPlayer';
import SVGIcon from '@/components/icons/SVGIcon';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'NodeAudio',
  components: {
    AudioRecorder,
    AudioPlayer,
    SVGIcon,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    ...mapFields('scale', [
      'layoutScale',
    ]),
    iconStyle() {
      return {
        'font-size': `${this.layoutScale * 12}px`,
      };
    },
  },
  methods: {
    ...mapActions('nodes', [
      'updateNode',
    ]),
    stopped(audioURL) {
      this.updateNode({
        node: {
          ...this.item,
          recordSrc: audioURL,
        },
      });
    },
    deleteRecord() {
      this.updateNode({
        node: {
          ...this.item,
          recordSrc: null,
        },
      });
    },
  },
};
</script>
